<template>
  <v-container fluid>
    <v-layout class="mb-4">
      <v-flex xs6 md6>
        <h3 class="title font-weight-bold">Create new Post</h3>
      </v-flex>
      <v-flex xs6 md6 class="text-xs-right">
        <el-button type="danger" size="small" @click="publishDialog = true">PUBLISH THIS POST</el-button>
      </v-flex>
    </v-layout>

    <v-layout class="mb-4">
      <v-flex xs12 md8>
        <el-card class="box-card">
          <el-form :label-position="`top`" ref="form" :model="form" label-width="150px">
            <el-form-item label="Post Type">
              <el-select
                v-model="form.post_type"
                placeholder="please select post type"
                @change="onPostTypeChanged"
              >
                <el-option label="Blog" value="blog"></el-option>
                <el-option label="Route" value="route"></el-option>
                <el-option label="Guide" value="guide"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Post Title">
              <el-input v-model="form.post_title"></el-input>
            </el-form-item>
            <el-form-item label="Post Slug">
              <el-input v-model="form.post_slug"></el-input>
            </el-form-item>
            <el-form-item label="Post Excerpt">
              <el-input type="textarea" rows="6" v-model="form.post_excerpt"></el-input>
            </el-form-item>
            <el-form-item label="Post Content">
              <ckeditor
                style="height:300px;"
                :editor="editor"
                v-model="form.post_content"
                :config="editorConfig"
              ></ckeditor>
            </el-form-item>
          </el-form>
        </el-card>
      </v-flex>
      <v-flex xs12 md4 class="pl-3">
        <el-card class="box-card">
          <div class="mb-2">
            <strong>Upload Image</strong>
          </div>
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
          >
            <img v-if="imageUrl" :src="form.featured_images" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

          <template v-if="form.post_attributes_json!=null">
            <template v-if="form.post_type=='route'">
              <el-form :label-position="`top`" ref="form" :model="form" label-width="150px">
                <el-form-item label="เส้นทาง">
                  <el-select
                    class="input-block mb-2"
                    v-model="form.post_attributes_json.route[0].name"
                    placeholder="select origin"
                  >
                    <el-option label="Bangkok" value="bangkok"></el-option>
                    <el-option label="Chiang Mai" value="route"></el-option>
                    <el-option label="Krabi" value="guide"></el-option>
                  </el-select>
                  <el-select
                    class="input-block"
                    v-model="form.post_attributes_json.route[1].name"
                    placeholder="select destination"
                  >
                    <el-option label="Bangkok" value="blog"></el-option>
                    <el-option label="Chiang Mai" value="route"></el-option>
                    <el-option label="Krabi" value="krabi"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </template>
            <template v-if="form.post_type=='guide'"></template>
          </template>
        </el-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="publishDialog" persistent transition="dialog-bottom-transition" width="700">
      <v-card>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>Publish this post</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark flat @click="publishDialog = false;">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
          <div>
            <div class="mb-2">
              <strong>Select Channel</strong>
            </div>
            <el-checkbox-group v-model="form.post_published_to">
              <el-checkbox label="hlz-web"></el-checkbox>
              <el-checkbox label="hlz-app"></el-checkbox>
              <el-checkbox label="halalroute"></el-checkbox>
              <el-checkbox label="halalhero"></el-checkbox>
            </el-checkbox-group>
          </div>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <el-button size="small" @click="onSubmit('draft')">Save as Draft</el-button>
          <el-button type="danger" size="small" @click="onSubmit('published')">Publish Now</el-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import Service from "../../services";

export default {
  components: {},
  data() {
    return {
      publishDialog: false,
      editor: ClassicEditor,
      editorData: "<p>Rich-text editor content.</p>",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote"
        ]
        // The configuration of the rich-text editor.
      },
      imageUrl: "",
      form: {
        post_status: "draft",
        post_type: "blog",
        post_title: "",
        post_slug: "",
        post_excerpt: "",
        post_content: "",
        post_attributes_json: null,
        post_categories_json: "",
        featured_images: "",
        post_published_to: []
      }
    };
  },
  created() {},
  methods: {
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("Avatar picture must be JPG format!");
      }
      if (!isLt2M) {
        this.$message.error("Avatar picture size can not exceed 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    onPostTypeChanged() {
      let attributes = {};
      if (this.form.post_type == "route") {
        attributes = {
          route: [
            { name: "จุดเริ่มต้น", coords: null },
            { name: "จุดหมายปลายทาง", coords: null }
          ]
        };
        this.form = { ...this.form, post_attributes_json: attributes };
      }
    },
    onSubmit(status) {
      this.form.post_status = status;
      Service.Cms.createPost(this.form).then(res => {
        console.log(res);
      });
    }
  }
};
</script>